import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import ChevronRight from '@mui/icons-material/ChevronRight';

import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import './ProviderLocations.scss';

const ProviderLocations = props => {
  const { provider, isMobile } = props;
  return (
    <CustomBox borderless className='ProviderLocationsComponent'>
      <CustomSubheader>
        Where I Treat
      </CustomSubheader>
      <Box paddingTop='2px'>
        <Typography variant='normal' color='text.light' component='p' lineHeight='normal' letterSpacing='0.1px'>
          {'(Please reach out to confirm service areas)'}
        </Typography>
      </Box>
      <Box className='ProviderLocations__location'>
        <ul>
          {(provider?.location_strings || []).map((str, i) => (
            <li key={i} style={{lineHeight: isMobile ? '0.875rem' : '1.25rem'}}>
              <Typography variant='normal' color='text.primary' lineHeight='1rem'>
                {str}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
      <Box className='ProviderLocations__image-map'>
        <Box marginBottom='0.938rem'>
          <Link underline="hover" variant="body" target='_blank' href={provider.mapImgUrl}>
            <Stack direction='row' alignItems='center'>
              <Typography variant='paragraphSmall500Inter' color='text.blue' lineHeight='1.375rem' letterSpacing='-0.5px'>
                {'View the map image'}
              </Typography>
              <ChevronRight style={{fontSize: '1.2rem'}}/>
            </Stack>
          </Link>
        </Box>

        <Stack direction='row' alignItems='center' justifyContent='center' className='ProviderLocations__image-map__img-box'>
          <img
            width='100%'
            src={provider.mapImgUrl}
            alt={`Map of ${provider.firstName} ${provider.lastName} MovementX physical therapy services in ${provider.primay_location}`}
          />
        </Stack>

      </Box>

    </CustomBox>
  );
};

export default ProviderLocations;
